// Close the drawer before navigating, including when the link only changes the hash.
document.addEventListener('click', async (event) => {
  const link = event.target.closest?.('.doobo-cart-signup__link');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const drawer = link.closest('theme-drawer');
  if (typeof drawer?.close !== 'function') return;

  event.preventDefault();
  const destination = new URL(link.href);
  const samePage = destination.pathname === location.pathname && destination.search === location.search;
  await drawer.close();
  if (samePage) {
    if (location.hash !== destination.hash) history.pushState(history.state, '', destination.href);
    const signup = document.getElementById('doobo-newsletter');
    signup?.focus({ preventScroll: true });
    signup?.scrollIntoView({ block: 'center', behavior: 'instant' });
  } else {
    location.assign(destination.href);
  }
});
